import React from 'react';
import Navigation from '../components/Navigation';

const About = () => {
    return (
        <div>
            <Navigation />
            <div className='about-container'>
                <div>
                    <h2>Page en cours de développement</h2>
                    <p>Revenez bientôt !</p>
                </div>
            </div>
        </div>
    );
};

export default About;